var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsx2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23.5,
    viewBox: "0 0 22 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "excel-file"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,23.7c-5.4,0-7.7-2.5-7.7-8.3V8.9C1.3,3.1,3.6.6,9,.6h5a.86.86,0,0,1,.8.8.86.86,0,0,1-.8.8H9C4.4,2.2,2.8,4,2.8,8.9v6.5c0,5,1.6,6.7,6.2,6.7h6c4.6,0,6.3-1.8,6.3-6.7V10a.8.8,0,1,1,1.6,0v5.4c0,5.8-2.3,8.3-7.8,8.3Z",
    transform: "translate(-1.1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,10.7c-3.3,0-4.6-1.4-4.6-5V1.5a.75.75,0,0,1,.5-.7.66.66,0,0,1,.7.2l7.8,8.4a.78.78,0,0,1,0,1.1.76.76,0,0,1-.5.2Zm-3.2-5c0,2.7.7,3.4,3.2,3.4H20L14.7,3.4Z",
    transform: "translate(-1.1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.3,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7,20.1H3.6a.68.68,0,0,1-.7-.7v-6a.68.68,0,0,1,.7-.7H15.7a.68.68,0,0,1,.7.7v6A.68.68,0,0,1,15.7,20.1Z",
    transform: "translate(-1.1 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(3.56 18.03)",
    fontSize: 5.5,
    fontFamily: "SegoeUI-Bold, Segoe UI",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "XSLX")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.1 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.1 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx2);
export default __webpack_public_path__ + "static/media/xlsx2.7f9d262b971ca10e457edd18f035e044.svg";
export { ForwardRef as ReactComponent };